import { render, staticRenderFns } from "./CarrierPicker.vue?vue&type=template&id=80993c10&scoped=true&"
import script from "./CarrierPicker.vue?vue&type=script&lang=js&"
export * from "./CarrierPicker.vue?vue&type=script&lang=js&"
import style0 from "./CarrierPicker.vue?vue&type=style&index=0&id=80993c10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80993c10",
  null
  
)

export default component.exports